import MoneyInput from 'components/MoneyInput';
import React from 'react';
import { Box } from '@mui/material';
import { useResourceContext } from 'ra-core';
import { useFormContext } from 'react-hook-form';
import { DisplayHelpers } from 'utils/helpers';
import { getInheritedSettings } from '../PositionRateSettingsForm.utils';
import { RATE_ADJUSTMENT_CENTS } from 'constants/rateSettings';
import { useRateControllerContext } from '../rateController/RateControllerContext';
import { RateFieldCheckbox } from './RateFieldCheckbox';

const INELIGIBLE_FOR_TEN_CENT_REDUCTION = ['AgencyLocationPositionRateSetting'];

type Props = { source: string; inheritedSettings: any };

export const ProfessionalRateInput = ({ source, inheritedSettings }: Props) => {
  const { watch } = useFormContext();
  const resource = useResourceContext();
  const { isControlled } = useRateControllerContext();

  const mergedSettings = getInheritedSettings({ source, inheritedSettings, watch });
  const show_ten_cent_reduction = !INELIGIBLE_FOR_TEN_CENT_REDUCTION.includes(resource);
  const { pro_rate_cents } = mergedSettings;
  // Guard against a null/undefined/blank pro rate rendering as -$0.10.
  const hasProRate =
    pro_rate_cents !== null && pro_rate_cents !== undefined && pro_rate_cents !== '';

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <MoneyInput
        source={`${source}.pro_rate_cents`}
        label="Professional Rate"
        disabled={!isControlled('professionalRate')}
        sx={{ flex: 1 }}
        helperText={
          show_ten_cent_reduction &&
          hasProRate &&
          `Adjusted rate: ${DisplayHelpers.money(Number(pro_rate_cents) - RATE_ADJUSTMENT_CENTS)}`
        }
      />
      <RateFieldCheckbox code="professionalRate" label="Admin controls Professional Rate" />
    </Box>
  );
};
